export const secret={
    apiKey: "AIzaSyCI7gMncgnfZluGFQjfBSw4tbkHQ_OyY3A",
    authDomain: "staffdocker.firebaseapp.com",
    databaseURL: "https://staffdocker-default-rtdb.firebaseio.com",
    projectId: "staffdocker",
    storageBucket: "staffdocker.appspot.com",
    messagingSenderId: "152256662660",
    appId: "1:152256662660:web:97eb6930a254d23b8186d1",
    measurementId: "G-5PZV2N9WQC"
  };